import Constants from '../Constants';

export interface HttpConfig {
  headers: Map<string, string>;
  timeout: number;
}

export class HttpClient {
  protected async get(url: string, token?: string, headers?: Map<String, String>, headersToRemove?: string[]): Promise<Response> {
    const finalHeaders = this.addTokenHeader(this.getConfig().headers, token);
    headers?.forEach((v: String, k: String) => {
      finalHeaders.set(k as string, v as string);
    })
    headersToRemove?.forEach(header => {
      finalHeaders.delete(header);
    })
    const options: RequestInit = {
      method: 'GET',
      headers: Object.fromEntries(finalHeaders),
    };
    return this.requestWithTimeout(url, options);
  }

  protected async post(url: string, data: any, token?: string): Promise<Response> {
    const headers = this.addTokenHeader(this.getConfig().headers, token);
    const options: RequestInit = {
      method: 'POST',
      headers: Object.fromEntries(headers),
      body: JSON.stringify(data),
    };
    return this.requestWithTimeout(url, options);
  }

  private getConfig(): HttpConfig {
    return {
      headers: new Map([
        ['Content-Type', 'application/json'],
        ['Accept', 'application/json'],
        ['X-Caller', Constants.APP_NAME],
      ]),
      timeout: Constants.API.TIMEOUT,
    };
  }

  private addTokenHeader(headers: Map<string, string>, token?: string): Map<string, string> {
    if (token) return headers.set('Authorization', `Bearer ${token}`);
    else return headers;
  }

  private async requestWithTimeout(url: string, options: RequestInit): Promise<Response> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), this.getConfig().timeout);

    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      clearTimeout(timeoutId);
      return response;
    } catch (error) {
      clearTimeout(timeoutId);
      throw error;
    }
  }
}
